import { ReactEditor, useSlateStatic } from "slate-react";
import { CustomElement } from "../../../../../slate";
import { useRef, useState } from "react";
import { Transforms } from "slate";
import { generateCode } from "../common";
import { moveArrayItemTo } from "../../../../hooks/useEditArray";


interface WithConfigurableTable {
  rows?: any[];
  is_collapsed?: boolean;
  is_forms?: boolean;
}


export const useConfigurableTable = (element: CustomElement & WithConfigurableTable) => {
    const editor = useSlateStatic();
    const insertedId = useRef<string | null>(null);
    
    // local state is needed to help react keep track of control state with the async updates by Slate/Transforms
    const [localState, setLocalState] = useState<WithConfigurableTable>({
        rows: element.rows || [],
        is_collapsed: element.is_collapsed,
        is_forms: element.is_forms,
    });
    
    const rows = localState.rows || [];

    const path = ReactEditor.findPath(editor, element);

    const updateState = (updated: WithConfigurableTable) => {
      setLocalState(updated);
      Transforms.setNodes(
          editor,
          updated as any,
          { at: path },
      );
    }

    const updateCollapsed = (value: boolean) => {
      updateState({ ...localState, is_collapsed: value });
    }
    const updateIsForms = (value: boolean) => {
      updateState({ ...localState, is_forms: value });
    }

    const insertRow = (at?: number) => {
      // setInsertedCode(newCode);
      const newRow = { _id: generateCode() }
      insertedId.current = newRow._id;

      updateState({
        ...localState,
        rows: (!at && at !== 0)
          ? [...rows, newRow ]
          : [...rows.slice(0, at), newRow, ...rows.slice(at)]
      })
    };

    const updateRow = (_id: string, changes: Partial<any>) => {
      updateState({
        ...localState,
        rows: rows.map(r => r._id === _id ? { ...r, ...changes } : r),
      });
    }

    const updateAllRows = (rows: any[]) => {
      updateState({
        ...localState,
        rows: rows.map(r => r._id ? r : { ...r, _id: generateCode() }),
      });
    }

    const duplicateRow = (_id: string) => {
      const rowIdx = rows.findIndex(r => r._id === _id);
      if(rowIdx >= 0) {
        const newRow = { ...rows[rowIdx], _id: generateCode() };
        insertedId.current = newRow._id;
        const at = rowIdx + 1;

        updateState({
          ...localState,
          rows: (!at && at !== 0)
          ? [...rows, newRow ]
          : [...rows.slice(0, at), newRow, ...rows.slice(at)]
        });
      }
    }

    const removeRow = (_id: string) => {
      updateState({
        ...localState,
        rows: rows.filter(r => r._id !== _id),
      });
    }

    const moveRow = (idxFrom: number, idxTo: number) => {
      updateState({
        ...localState,
        rows: moveArrayItemTo(rows, idxFrom, idxTo),
      });
    }

    return {
      rows,
      insertRow,
      duplicateRow,
      updateRow,
      updateAllRows,
      removeRow,
      moveRow,

      insertedId: insertedId.current,

      isCollapsed: !!localState.is_collapsed,
      updateCollapsed,
      isForms: !!localState.is_forms,
      updateIsForms,
    }
}
